export const NotFoundPage = () => <div>Page not found</div>;
